import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { FaSpinner } from "react-icons/fa";

export function LoadingIndicator({ message }) {

    return (
        <div className="d-flex flex-column align-items-center text-success mt-4">
            <AnimatePresence>
                <motion.div
                    animate={{ rotate: 360 }}
                    style={{
                        display: 'inline-block',
                        width: '40px',
                        height: '40px',
                        marginBottom: '10px'
                    }}
                    transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
                >
                    <FaSpinner className="fa-spin mb-2" size={32} style={{
                        fontSize: '2.5rem',
                        color: '#198754',
                        width: '100%',
                        height: '100%'
                    }} />
                </motion.div>
            </AnimatePresence>
            <span>{message}</span>
        </div>
    )
}

export default LoadingIndicator;